/**
 * Local development environment for marketing-app
 */
export const environment = {
  production: false,
  configServer: {
    apiUrl: '/api/configs',
    projectId: 'tt-schooladmin',
    appId: 'marketing-app',
  },
  baseApiUrl: 'http://127.0.0.1:5001/tt-common-project-dev/asia-south1/sms_api',
  useEmulators: true,
  firebase: {
    apiKey: 'fake-api-key-for-emulator',
    authDomain: 'tt-common-project-dev.firebaseapp.com',
    projectId: 'tt-common-project-dev',
    storageBucket: 'tt-common-project-dev.firebasestorage.app',
    messagingSenderId: '12891861518',
    appId: '1:12891861518:web:6929b4e899be4a4685c25f',
  },
  tracking: {
    googleAdsId: '', // No tracking in development
    measurementId: '', // No GA4 tracking in development
  },
};
